import { render, staticRenderFns } from "./template.vue?vue&type=template&id=aae96ef8&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=aae96ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae96ef8",
  null
  
)

export default component.exports